import React from 'react'
import { IconText, Box, Text } from './'

const Button = ({
  className,
  theme,
  inverted,
  events,
  disabled,
  icon,
  icontextprops,
  reversed,
  ...props
}) => (
  <Box
    className={`gp-button theme theme-${theme} ${className} ${
      inverted ? 'inverted' : ''
    } ${disabled ? 'disabled' : ''}`}
    {...events}
    {...props}
    onClick={(e) => (disabled ? e : events.onClick ? events.onClick(e) : e)}
  >
    {icon ? (
      <IconText
        group={icon.group}
        value={icon.value}
        icon={icon.name}
        {...icontextprops}
        {...(reversed ? { reversed: true } : {})}
      />
    ) : (
      <Text>{props.text}</Text>
    )}

    {props.children}
  </Box>
)

Button.defaultProps = {
  className: '',
  style: {},
  events: {},

  group: 'a3',
  theme: '',
  icontextprops: {}
}

export default Button
